import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 30 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionTitle = ({ kicker, title, className = "" }) => (
  <Reveal className={`mb-10 max-w-2xl ${className}`}>
    {kicker && <p className="font-head mb-3 inline-block -rotate-2 rounded-full bg-[var(--km-cyan)] px-4 py-1 text-sm font-bold text-[#0b0114]">{kicker}</p>}
    <h2 className="font-display text-4xl leading-tight text-white sm:text-5xl">{title}</h2>
  </Reveal>
);
